import { PapiExtendedDeviation, PapiEditorText } from '@wix/da-papi-types';

export enum OriginalDeviationFieldName {
  TITLE = 'title',
  DESCRIPTION = 'description',
  MATURE_CONTENT = 'matureContent',
  NO_AI = 'noAi',
  IS_AI_GENERATED = 'isAiGenerated',
  PRICE = 'price',
  TAGS = 'tags',
  DELIVERY_TIME = 'deliveryTime',
  DISPLAY_RESOLUTION = 'displayResolution',
  ADD_WATERMARK = 'addWatermark',
  PROGRESS_IS_VISIBLE = 'progressIsVisible',
  QUESTIONS = 'questions',
}

export interface OriginalDeviationFormFields {
  [OriginalDeviationFieldName.TITLE]: string;
  [OriginalDeviationFieldName.DESCRIPTION]: () => string;
  [OriginalDeviationFieldName.MATURE_CONTENT]: boolean;
  [OriginalDeviationFieldName.NO_AI]: boolean;
  [OriginalDeviationFieldName.IS_AI_GENERATED]: boolean;
  [OriginalDeviationFieldName.PRICE]: number;
  [OriginalDeviationFieldName.TAGS]: string[];
  [OriginalDeviationFieldName.DELIVERY_TIME]: number;
  [OriginalDeviationFieldName.DISPLAY_RESOLUTION]: number;
  [OriginalDeviationFieldName.ADD_WATERMARK]: boolean;
  [OriginalDeviationFieldName.PROGRESS_IS_VISIBLE]: boolean;
  [OriginalDeviationFieldName.QUESTIONS]: QuestionWithEditorState[];
}

export enum QuestionFieldName {
  QUESTION_BODY = 'questionBody',
  QUESTION_TYPE = 'questionType',
  ANSWER_CHOICES = 'answerChoices',
  IS_REQUIRED = 'isRequired',
}

export interface QuestionFormFields {
  [QuestionFieldName.QUESTION_BODY]: () => string;
  [QuestionFieldName.QUESTION_TYPE]: QuestionType;
  [QuestionFieldName.IS_REQUIRED]: boolean;
  [QuestionFieldName.ANSWER_CHOICES]?: AnswerChoice[];
}

export type Question = NonNullable<
  PapiExtendedDeviation['originals']
>['questionnaire'][number];

export interface QuestionWithEditorState
  extends Omit<Question, 'position' | 'question'> {
  question?: PapiEditorText;
  questionEditor?: () => string;
}

export type QuestionType = Question['type'];

export type AnswerChoice = NonNullable<Question['answers']>[number];
